import React from "react";
import { DashboardOnboardingStatus } from "../pages/get-started/types";
import {
  getOnboardingStepCount,
  TOTAL_ONBOARDING_STEPS,
} from "../pages/get-started/utils/onboardingUtils";

interface GetStartedTaskCompleteCounterProps {
  dashboardOnboardingStatus: DashboardOnboardingStatus | null;
}

const GetStartedTaskCompleteCounter = ({
  dashboardOnboardingStatus,
}: GetStartedTaskCompleteCounterProps) => {
  return (
    <span>
      <text className="text-sm font-medium text-gray-40">
        {getOnboardingStepCount(dashboardOnboardingStatus)} / {TOTAL_ONBOARDING_STEPS}
      </text>
    </span>
  );
};

export default GetStartedTaskCompleteCounter;
